import { EnvironmentNames } from '../../lib/_core/constants/environments';
import { EFT_INSTRUCTIONS_IGF, WIRING_INSTRUCTIONS_IGF } from '../../lib/_core/constants/wiring-instructions';
import { environment as swissEnv } from '../swiss/environment.swiss-prod';

export const environment = {
  fund: {
    primaryColor: 'rgb(14, 80, 160)',
    secondaryColor: 'rgb(217, 245, 255)',
    ternaryColor: 'rgb(14, 80, 160)',
    logo: 'assets/logos/igf.png',
    publicLogo: 'assets/logos/igf.jpg',
    lightDonateNowButtonLink:
      'https://6239938.app.netsuite.com/core/media/media.nl?id=8920&c=6239938&h=rqLCGoMmz7vNMXf-n21TWsB7q7Gw-EgfNlodiqHHQBCSPeSp',
    darkDonateNowButtonLink:
      'https://6239938.app.netsuite.com/core/media/media.nl?id=8919&c=6239938&h=CFtL0XFgeXCzhkAiMOlwV0HyYr_FEUm-ukT0Y15DmoJ-GZs0',
    lightDonateNowButtonSrc: 'assets/donate-buttons/igf_light_donate_button.png',
    darkDonateNowButtonSrc: 'assets/donate-buttons/igf_dark_donate_button.png',
    favicon: 'assets/favicon/igf.ico',
    wiringInstructions: WIRING_INSTRUCTIONS_IGF,
    eftInstructions: EFT_INSTRUCTIONS_IGF,
    stripeKey:
      'pk_live_51HuFjyHMk9YjNmdl8ic18MWtwCRZ3Ml9G4nxh95Jb7vxJ4PUdxF3EqzH8s6OT16kjjL40CXjai1xa2lfDlPeUpBj00yIxMFprB',
    homeLink: 'https://www.internationalgenerosity.com/',
    contact:
      'https://6239938.extforms.netsuite.com/app/site/crm/externalleadpage.nl?compid=6239938&formid=2&h=AAFdikaIdKlYEs4FAj_L3P74vXUHG8WCn2Ke3jOQPWsYKkn0qHs&custenity_refer_source=web-portal',
    blog: '',
    privacyPolicy: 'https://www.internationalgenerosity.com/privacy',
    terms: 'https://www.internationalgenerosity.com/terms',
    mailTo: 'admin@internationalgenerosity.com',
    name: 'International Generosity Foundation',
    tenantId: 'igf_prod',
    server: 'https://portal.internationalgenerosity.com/api',
    url: 'http://portal.internationalgenerosity.com',
    gsUrl: 'https://givingspace.trustbridgeglobal.com/',
    environmentName: EnvironmentNames.IGF,
    languages: ['en-igf'],
    production: true,
    multiCurrency: false,
    redirectSourceUrl: swissEnv.fund.url,
    signatureApiKey: '',
  },
};
